import axios from "axios";
import CONFIG from "../config";
import { attachAuthInterceptor } from "./authInterceptor";

export const BASE_API_URL = CONFIG.EMPLOYEE_SERVICE_URL;

const api = axios.create({
  baseURL: BASE_API_URL,
});

attachAuthInterceptor(api, { refreshBaseUrl: BASE_API_URL });

export default api;
